import React from 'react'
import NavigationBar from './NavigationBar'

import Container from 'react-bootstrap/Container'
import Form from 'react-bootstrap/Form'
import Buuton from './Buuton'


export const Contact = () =>(
    <div>
        <NavigationBar />
        <Container>
            
            <h1>Contact me</h1>

            <Form.Group controlId="exampleForm.ControlTextarea1">
                <Form.Label>How Can I Help You?</Form.Label>
                <Form.Control as="textarea" rows="6" />
            </Form.Group>

            <Form.Group controlId="exampleForm.ControlInput1">
                <Form.Label>Your Email</Form.Label>
                <Form.Control type="email" placeholder="name@example.com" />
            </Form.Group>

            <Buuton text="send"/>

        </Container>
    </div>
)
